import { render, staticRenderFns } from "./IconBed.vue?vue&type=template&id=104bc9c8&"
import script from "./IconBed.vue?vue&type=script&lang=js&"
export * from "./IconBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports